
import { truly, falsy, isBoolean } from './supports/boolean';
import query from './supports/query';
import ready from './supports/ready';
import select from './supports/select';
import throttle from './supports/throttle';
import wait from './supports/wait';

// import * as floating from '@floating-ui/dom';

const app = {
    props: new Map,

    // State handling
    states: {
        loaded: false,
        ready: false
    },
    setState(state, newValue, detail) {
        if (typeof detail === 'undefined') {
            detail = {
                oldValue: app.states[state],
                newValue
            };
        }

        const event = new CustomEvent(`app:${state}`, {
            detail
        });

        app.states[state] = newValue;
        document.dispatchEvent(event);
    },

    // Core functions
    truly,
    falsy,
    isBoolean,
    query,
    ready,
    select,
    throttle,
    wait,

    vendors: {
        // floating
    }
};
window.app = app;
